export default "__VITE_ASSET__DJp$k3_e__"